exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/template/sections/content/select.scss
// module id = 6167
// module chunks = 0